import { TAILWIND_COLORS } from "#src/utils/common";
import { Tooltip } from "@lockerpm/design";
import { HelpCircle } from "@untitled-ui/icons-react";
import { ReactNode } from "react";

interface IFormFieldWrapperProps {
  label: string;
  children?: ReactNode;
  requiredMark?: boolean;
  error?: string | null;
  hint?: ReactNode;
  tooltip?: ReactNode;
}

/** In a form, each field should have at least label, required mark, some kinds of input, hint text & errors. */
export const FormFieldWrapper = ({
  label,
  children,
  requiredMark,
  error,
  hint,
  tooltip,
}: IFormFieldWrapperProps) => {
  return (
    <div className="flex flex-col gap-1.5 h-fit">
      <span className="flex items-center gap-0.5 text-sm font-medium text-gray-v2-700">
        {label}{" "}
        {requiredMark ? <span className="text-brand-v2-600">*</span> : null}
        {tooltip ? (
          <Tooltip
            color={TAILWIND_COLORS["gray-v2-900"]}
            title={
              <p className="text-xs text-white font-semibold text-center">
                {tooltip}
              </p>
            }
          >
            <HelpCircle className="h-4 w-4 min-w-4 text-gray-v2-400 cursor-pointer" />
          </Tooltip>
        ) : null}
      </span>
      {children}
      {error ? (
        <div className="text-sm text-error-v2-600">{error}</div>
      ) : hint ? (
        <div className="text-sm text-gray-v2-600">{hint}</div>
      ) : null}
    </div>
  );
};
